/**
 * The slack at the end of a bounded scrollport's travel, shared by every
 * scroller the widget kit and the DataTable own.
 *
 * A scrollport that stops dead on its last row, or on a fixed 32px of
 * slack, leaves the last rows pinned to the bottom edge of a tall card. So
 * the slack is HALF the scrollport's own height, with the fixed gutter as
 * its floor: the last row can travel up to the middle of the box, as an
 * editor's scroll-past-end does.
 *
 * `cqh` resolves against the nearest ancestor that is a SIZE query
 * container, so the element whose height IS the scrollport's (a ScrollArea
 * root, the DataTable's scroll box) wears `SCROLLPORT_CONTAINER_CLASS` — and
 * only an element whose height is definite may wear it: size containment
 * makes a box's size independent of its content, so a content-hugging box
 * made a container collapses to nothing. The HOST must therefore give the
 * scrollport a definite height (a grid cell, a fixed or flex-filled box). Without a container the unit falls
 * back to the viewport, and half a window of slack would open under a
 * short list — so the two classes travel together.
 *
 * The slack is scroll CONTENT, gated by the scroller on "the content already
 * overflows": a body that fits keeps its resting foot, and one that
 * overflows by a pixel gains the whole slack and stays overflowing, so the
 * gate cannot oscillate.
 */
export const SCROLLPORT_CONTAINER_CLASS = "[container-type:size]";

/** The slack's size: half the scrollport. A min-height, so a fixed gutter
 *  on the same box stays its floor. */
export const SCROLL_END_SLACK_CLASS = "min-h-[50cqh]";
